export default class Modals {
    static give = "give";
}